import { createTheme } from "@mui/material/styles";
import './ThemeTypes';

const GenerdisTheme = createTheme({
    palette: {
        common: {
            black: "#343434",
        },
        primary: {
            main: "#04cccc",
            light: "#1ce6e6",
            dark: "#039b9b"
        },
        secondary: {
            main: "#1ca4d0",
            light: "#4db9dd",
            dark: "#147a9d"
        },
        surface: {
            main: "#ffffffff",
        }
    },
});
export default GenerdisTheme;